import AtomicIndex from "../../../../src/courses/partials/atomic/index.mdx";
import * as React from 'react';
export default {
  AtomicIndex,
  React
};